import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { TRACK_PAGE_EVENT } from '@tools/ui/mutations';
import {
  EventExtraDataInput,
  EventType
} from '@tools/ui/types/generated/graphql';
import { userStore } from '@tools/ui-stores';
import { parseUrl } from './utils/mos-analytics';

export const useEventTracker = ({
  eventType,
  extraData
}: {
  eventType: EventType;
  extraData?: EventExtraDataInput;
}) => {
  const params = useParams();
  const [trackPageEventMutation] = useMutation(TRACK_PAGE_EVENT);

  const trackEvent = useCallback(() => {
    if (!userStore.currentUser?._id) {
      return;
    }

    try {
      const currentUrl =
        typeof window !== 'undefined' ? window.location.href : '';

      const eventData = {
        eventType,
        pageTitle: typeof document !== 'undefined' ? document.title : '',
        url: parseUrl(currentUrl, params),
        rawUrl: currentUrl,
        extraData
      };

      trackPageEventMutation({
        variables: {
          input: eventData
        }
      }).catch((error) => {
        console.error(`Failed to track ${eventType} event`, { error });
      });
    } catch (error) {
      console.error(`Error preparing ${eventType} event`, { error });
    }
  }, [eventType, params, trackPageEventMutation, extraData]);

  return { trackEvent };
};
